import { render, staticRenderFns } from "./XcalacocoBookingsFilters.vue?vue&type=template&id=61525438&"
import script from "./XcalacocoBookingsFilters.vue?vue&type=script&lang=js&"
export * from "./XcalacocoBookingsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports